import React from "react";
import { FooterLink, FooterLinkProps } from "./FooterLink";

export interface FooterLinkListProps {
  title: string;
  links: Array<FooterLinkProps>;
}

export const FooterLinkList = ({ title, links }: FooterLinkListProps) => {
  return (
    <div className="mb-4xl last:mb-0">
      <div className="mb-xl text-sm-semibold text-secondary-on-brand">
        {title}
      </div>
      <ul className="list-none m-0 p-0">
        {links.map((link) => (
          <FooterLink key={`${link.href}-${link.label}`} {...link} />
        ))}
      </ul>
    </div>
  );
};
